import React, { useEffect, useRef, useState, useCallback } from 'react';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { classNames } from 'primereact/utils';
import { Dropdown } from 'primereact/dropdown';
import { useFormik } from 'formik';
import { Dialog } from 'primereact/dialog';
import { Api } from "../../../../services/api";
import { Toast } from 'primereact/toast'
import { InputNumber } from 'primereact/inputnumber';
import { Checkbox } from 'primereact/checkbox';
import { BiCheck } from 'react-icons/bi';
import { debounce } from 'lodash';

import { Tooltip } from 'primereact/tooltip';

const ProjectionAddModel = ({ visible, projection, closeModel, setMonth, setYear }) => {

    const [isModalOpen, setIsModalOpen] = useState(true);
    const toast = useRef(null);
    const [type, setType] = useState('Add');
    const [userId, setUserID] = useState('');
    const [reconciled, setReconciled] = useState('N');
    const [reconciledDataAdd, setReconciledDataAdd] = useState('N');


    const months = [
        { name: 'Jan', code: 'Jan' },
        { name: 'Feb', code: 'Feb' },
        { name: 'Mar', code: 'Mar' },
        { name: 'Apr', code: 'Apr' },
        { name: 'May', code: 'May' },
        { name: 'Jun', code: 'Jun' },
        { name: 'Jul', code: 'Jul' },
        { name: 'Aug', code: 'Aug' },
        { name: 'Sep', code: 'Sep' },
        { name: 'Oct', code: 'Oct' },
        { name: 'Nov', code: 'Nov' },
        { name: 'Dec', code: 'Dec' },
    ];

    // ------------------------------------------------------------
    const generateYearOptions = (startYear, endYear) => {
        const years = [];
        for (let year = startYear; year <= endYear; year++) {
            years.push({ name: year.toString(), code: year.toString() });
        }
        return years;
    };

    const years = generateYearOptions(2021, 2030);
    // ------------------------------------------------------------
    const isFormFieldInvalid = (name) => !!(formik.touched[name] && formik.errors[name]);
    // -------------------------------------------------------------


    useEffect(() => {
        setIsModalOpen(true);
        formik.resetForm();
        setType('Add');
        if (projection.length != 0) {
            editCopyModal(projection, 'Edit');
        }
        if (setMonth) {
            getDataForMonth();
        }

    }, [visible]);

    const getDataForMonth = () => {
        var url = Api.API_BASE_URL + 'get-income-statement-setting';
        const token = localStorage.getItem('authToken');

        // Create headers with token if it exists
        const headers = {
            'Content-Type': 'application/json',
            'Authorization': token ? `Bearer ${token}` : ''
        };
        var _body = {
            month: setMonth,
            year: setYear
        }
        formik.setFieldValue('year', { name: setYear.toString(), code: setYear.toString() });
        formik.setFieldValue('month', { name: setMonth.toString(), code: setMonth.toString() });
        fetch(url, {
            method: "POST",
            headers: headers,
            body: JSON.stringify(_body),
        })
            .then((response) => response.json())
            .then((Josn) => {
                if (Josn.error != '') {

                } else {
                    if (Josn.find == true) {
                        editCopyModal(Josn, 'Edit');
                    } else {
                        Josn.result.year = setYear;
                        Josn.result.month = setMonth;
                        setType('Add');
                        editCopyModal(Josn, 'Add');
                    }
                }
            })
            .catch((error) => {
                console.error("Error:", error);
            });
    }

    const editCopyModal = (Json, colType) => {
        var rowData = Json.result;

        setUserID(rowData.id);
        setType(colType);
        // setIsModalOpen(true);

        formik.setFieldValue('re_complated', rowData.re_complated);
        formik.setFieldValue('AdminWagesFixedTick', rowData.AdminWagesFixedTick);

        formik.setFieldValue('totalOtherIncome', rowData.totalOtherIncome);
        formik.setFieldValue('totalIncome', rowData.totalIncome);

        // if (rowData.totalIncome == 0) {
        //     formik.setFieldValue('totalIncome', Json.total_income);
        // }


        formik.setFieldValue('gross_profit_box', rowData.gross_profit_box);

        formik.setFieldValue('poc', rowData.poc);
        formik.setFieldValue('cogsTotal', rowData.cogsTotal);
        
        // if (rowData.cogsTotal == 0) {
        //     formik.setFieldValue('cogsTotal', Json.cogs_total_income);
        // }

        formik.setFieldValue('uncategorized', rowData.uncategorized);
        formik.setFieldValue('MarketingSales', rowData.MarketingSales);
        formik.setFieldValue('AdminWages', rowData.AdminWages);
        formik.setFieldValue('vpConstructionOperations', rowData.vpConstructionOperations);
        formik.setFieldValue('Facilities', rowData.Facilities);
        formik.setFieldValue('GeneralAdmin', rowData.GeneralAdmin);
        formik.setFieldValue('Office', rowData.Office);
        formik.setFieldValue('TotalOtherCurrentAssets', rowData.TotalOtherCurrentAssets);
        formik.setFieldValue('NumberOfEmployees', rowData.NumberOfEmployees);
        formik.setFieldValue('NumberOfManagementStaff', rowData.NumberOfManagementStaff);
        formik.setFieldValue('NumberOfPms', rowData.NumberOfPms);
        formik.setFieldValue('TotalAccountsReceievable', rowData.TotalAccountsReceievable);
        formik.setFieldValue('MaterialsForFutureJobs', rowData.MaterialsForFutureJobs);
        formik.setFieldValue('DueFromToShareholder', rowData.DueFromToShareholder);
        formik.setFieldValue('WipCostsInExcessOfBillings', rowData.WipCostsInExcessOfBillings);
        formik.setFieldValue('TotalFixedAssets', rowData.TotalFixedAssets);
        formik.setFieldValue('TotalOtherAssets', rowData.TotalOtherAssets);
        formik.setFieldValue('TotalCurrentAssets', rowData.TotalCurrentAssets);
        formik.setFieldValue('TotalCurrentLiabilities', rowData.TotalCurrentLiabilities);
        formik.setFieldValue('TotalLongTermLiabilities', rowData.TotalLongTermLiabilities);
        formik.setFieldValue('TotalEquity', rowData.TotalEquity);
        formik.setFieldValue('CorpTaxPaid', rowData.CorpTaxPaid);
        formik.setFieldValue('ConstructionFinancing', rowData.ConstructionFinancing);
        formik.setFieldValue('ToBalanceCash', rowData.ToBalanceCash);
        formik.setFieldValue('cashend', Json.cashend);
        formik.setFieldValue('previousTotalAccountsReceievable', Json.previousTotalAccountsReceievable);
        formik.setFieldValue('previousTotalCurrentLiabilities', Json.previousTotalCurrentLiabilities);
        formik.setFieldValue('previousTotalLongTermLiabilities', Json.previousTotalLongTermLiabilities);

        formik.setFieldValue('custome_home_and_renovation', rowData.custome_home_and_renovation);
        formik.setFieldValue('commercial_and_multi_family', rowData.commercial_and_multi_family);

        formik.setFieldValue('total_income_forecast', Json.total_income_forecast);
        formik.setFieldValue('total_cogs_forecast', Json.total_cogs_forecast);        
    }

    const formik = useFormik({
        initialValues: {
            year: '',
            month: '', 
            re_complated: 'N',
            AdminWagesFixedTick: 'N',
            uncategorized: '',
            MarketingSales: '',
            totalIncome: '',
            poc: '',
            cogsTotal: '',
            AdminWages: '',
            vpConstructionOperations: '',
            Facilities: '',
            GeneralAdmin: '',
            Office: '',
            TotalOtherCurrentAssets: '',
            NumberOfEmployees: '',
            NumberOfManagementStaff: '',
            NumberOfPms: '',
            TotalAccountsReceievable: '',
            MaterialsForFutureJobs: '',
            DueFromToShareholder: '',
            WipCostsInExcessOfBillings: '',
            TotalFixedAssets: '',
            TotalOtherAssets: '',
            TotalCurrentAssets: '',
            TotalCurrentLiabilities: '',
            TotalLongTermLiabilities: '',
            TotalEquity: '',
            CorpTaxPaid: '',
            ConstructionFinancing: '',
            ToBalanceCash: '',
            totalOtherIncome: '',
            gross_profit_box: '',
            previousTotalAccountsReceievable: 0,
            previousTotalCurrentLiabilities: 0,
            previousTotalLongTermLiabilities: 0,
            custome_home_and_renovation: '',
            commercial_and_multi_family: '',

            total_income_forecast: '',
            total_cogs_forecast: ''

        },

        validate: (data) => {
            let errors = {};

            if (!data.year) {
                errors.year = 'please select a year.';
            }
            if (!data.month) {
                errors.month = 'please select a month.';
            }
            return errors;
        },

        onSubmit: (data) => {
            // var url = Api.API_BASE_URL + 'get-income-statement-setting';
            // const token = localStorage.getItem('authToken');

            // const headers = {
            //     'Content-Type': 'application/json',
            //     'Authorization': token ? `Bearer ${token}` : ''
            // };
            // var _body = {
            //     month: data.month.code,
            //     year: data.year.code
            // }

            // fetch(url, {
            //     method: "POST",
            //     headers: headers,
            //     body: JSON.stringify(_body),
            // })
            //     .then((response) => response.json())
            //     .then((Json) => {
            //         if (Json.error != '') {
            //             toast.current.show({ severity: 'error', summary: 'Error', detail: Json.error });
            //         } else {
            //             setIsModalOpen(false);
            //             // closeModel(Json); // Pass the fetched data back to parent
            //             closeModel();
            //         }
            //     })
            //     .catch((error) => {
            //         console.error("Error:", error);
            //         toast.current.show({ severity: 'error', summary: 'Error', detail: 'Failed to fetch data' });
            //     });

            // setIsModalOpen(false);
            closeModel();
        }
    });

    // const renderInputArea = (fieldName, title, showCheckbox = false) => (
    //     <div className="col-6 p-2">
    //         <label className='text-gray-600 text-sm'>{title}</label>
    //         {/* {showCheckbox && (
    //             <Checkbox
    //                 name="AdminWagesFixedTick"
    //                 value={formik.values.AdminWagesFixedTick}
    //                 checked={formik.values.AdminWagesFixedTick == 'Y' ? true : false}
    //                 onChange={(e) => {
    //                     formik.setFieldValue('AdminWagesFixedTick', e.target.checked ? 'Y' : 'N');
    //                 }}

    //             />

    //         )} */}
    //         <InputNumber
    //             inputId={formik.values[fieldName] < 0 ? 'number-negataive-price' : 'currency-positive'}
    //             id={fieldName}
    //             name={fieldName}
    //             mode="currency" currency="USD" locale="en-US"
    //             value={formik.values[fieldName]}
    //             className={classNames('pt-1',)} style={{ width: '100%' }}
    //             onChange={(e) => {
    //                 formik.setFieldValue(fieldName, e.value)
    //             }}
    //         />
    //     </div>


    // );



// Move debounced API call outside renderInputArea
const createDebouncedApiCall = (fieldName, formikValues, reconciledDataAdd, toast) => {
  return debounce((value) => {
    const url = Api.API_BASE_URL + 'save-income-statement-setting';
    const token = localStorage.getItem('authToken');
    const headers = {
      'Content-Type': 'application/json',
      'Authorization': token ? `Bearer ${token}` : ''
    };

    const data = {
      ...formikValues,
      [fieldName]: value,
      fieldName: fieldName,
      fieldValue: value,
      reconciledDataAdd
    };

    fetch(url, {
      method: "POST",
      headers,
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .then((json) => {
        if (json.error) {
          toast.current.show({ severity: 'error', summary: 'Error', detail: json.error });
        }
        toast.current.show({ severity: 'success', summary: 'Success', detail: fieldName + ' updated' });
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  }, 1000);
};



const renderInputArea = (fieldName, title, tooltipText) => {
  const debouncedApiCall = createDebouncedApiCall(fieldName, formik.values, reconciledDataAdd, toast);

  return (
    <div className="col-6 p-2">
      <Tooltip target={`.tooltip-${fieldName}`} position="top" />
      <label className='text-gray-600 text-sm'>
        {title}
        {tooltipText && (
          <i
            className={`pi pi-info-circle tooltip-${fieldName} ml-2`}
            data-pr-tooltip={tooltipText}
            data-pr-position="top"
            style={{ cursor: 'pointer' }}
          />
        )}
      </label>
      <InputNumber
        inputId={formik.values[fieldName] < 0 ? 'number-negataive-price' : 'currency-positive'}
        id={fieldName}
        name={fieldName}
        mode="currency"
        currency="USD"
        locale="en-US"
        value={formik.values[fieldName]}
        className={classNames('pt-1')}
        style={{ width: '100%' }}
        onChange={(e) => {
          formik.setFieldValue(fieldName, e.value);
          debouncedApiCall(e.value);
        }}
      />
    </div>
  );
};

        
    const renderInputArea2 = (fieldName, title, tooltipText) => {
      // Sanitize fieldName to create a valid CSS class name
      const sanitizedFieldName = `tooltip-${fieldName.toString().replace(/[^a-zA-Z0-9]/g, '-')}`;
    
      return (
        <div className="col-6 p-2">
          {/* Tooltip Component */}
          <Tooltip target={`.${sanitizedFieldName}`} position="top" />
    
          {/* Label with Tooltip */}
          <label className="text-gray-600 text-sm">
            {title}
            {tooltipText && (
              <i
                className={`pi pi-info-circle ${sanitizedFieldName} ml-2`}
                data-pr-tooltip={tooltipText}
                data-pr-position="top"
                style={{ cursor: 'pointer' }}
              />
            )}
          </label>
    
          {/* InputNumber */}
          <InputNumber
            disabled
            inputId={fieldName < 0 ? 'number-negataive-price' : 'currency-positive'}
            id={fieldName}
            className="p-inputnumber bold-input"
            name={fieldName}
            mode="currency"
            currency="USD"
            locale="en-US"
            value={fieldName}
            style={{ width: '100%', backgroundColor: '#DDDDDD', fontWeight: 'bold' }}
            onChange={(e) => {
              // formik.setFieldValue(fieldName, e.target.value)
            }}
          />
        </div>
      );
    }; 

    const renderInputAreaPer = (fieldName, title, tooltipText) => {
        // Sanitize fieldName to create a valid CSS class name
        const sanitizedFieldName = `tooltip-${fieldName.toString().replace(/[^a-zA-Z0-9]/g, '-')}`;
      
        return (
          <div className="col-6 p-2">
            {/* Tooltip Component */}
            <Tooltip target={`.${sanitizedFieldName}`} position="top" />
      
            {/* Label with Tooltip */}
            <label className="text-gray-600 text-sm">
              {title}
              {tooltipText && (
                <i
                  className={`pi pi-info-circle ${sanitizedFieldName} ml-2`}
                  data-pr-tooltip={tooltipText}
                  data-pr-position="top"
                  style={{ cursor: 'pointer' }}
                />
              )}
            </label>
      
            {/* InputNumber */}
            <InputNumber
              disabled
              inputId={fieldName < 0 ? 'number-negataive-price' : 'currency-positive'}
              id={fieldName}
              className="p-inputnumber bold-input"
              name={fieldName}
              suffix="%"
              value={fieldName}
              style={{ width: '100%', backgroundColor: '#DDDDDD', fontWeight: 'bold' }}
              mode="decimal"
              minFractionDigits={2} // Ensure at least 2 digits after the decimal
              maxFractionDigits={2} // Limit to 2 digits after the decimal
            />
          </div>
        );
      };

    const getCashEndData = () => {
        var subTotal = ((Number(formik.values.totalIncome) === 0 ? Number(formik.values.total_income_forecast) : Number(formik.values.totalIncome)) + Number(formik.values.poc) + Number(formik.values.totalOtherIncome) + Number(formik.values.cashend)) - (Number(formik.values.cogsTotal) + Number(formik.values.uncategorized) + Number(formik.values.MarketingSales) + Number(formik.values.AdminWages) + Number(formik.values.vpConstructionOperations) + Number(formik.values.Facilities) + Number(formik.values.Office) + Number(formik.values.GeneralAdmin));

        var bv30To37 = (Number(formik.values.TotalOtherCurrentAssets) + Number(formik.values.MaterialsForFutureJobs) + Number(formik.values.DueFromToShareholder) + Number(formik.values.WipCostsInExcessOfBillings) + Number(formik.values.TotalFixedAssets) + Number(formik.values.TotalOtherAssets) + Number(formik.values.TotalCurrentAssets));

        var bv42to46 = (Number(formik.values.CorpTaxPaid) + Number(formik.values.ConstructionFinancing) + Number(formik.values.ToBalanceCash));
        var bj32to34 = (Number(formik.values.MaterialsForFutureJobs) + Number(formik.values.DueFromToShareholder) + Number(formik.values.WipCostsInExcessOfBillings));


        // formik.setFieldValue('previousTotalAccountsReceievable', rowData.previousTotalAccountsReceievable);
        // formik.setFieldValue('previousTotalCurrentLiabilities', rowData.previousTotalCurrentLiabilities);
        // formik.setFieldValue('previousTotalLongTermLiabilities', rowData.previousTotalLongTermLiabilities);
        var previousTotalAccountsReceievable = (Number(formik.values.previousTotalAccountsReceievable) - Number(formik.values.TotalAccountsReceievable));
        var previousTotalCurrentLiabilities = (Number(formik.values.TotalCurrentLiabilities) - Number(formik.values.previousTotalCurrentLiabilities));


        var previousTotalLongTermLiabilities = (Number(formik.values.previousTotalLongTermLiabilities) - Number(formik.values.TotalLongTermLiabilities));

        var cashEnd = subTotal + bv30To37 + bv42to46 - bj32to34 + previousTotalAccountsReceievable + previousTotalCurrentLiabilities - previousTotalLongTermLiabilities;
        return cashEnd;
    }

    const getTotalExpenses = () => {
        return (
            Number(formik.values.uncategorized) +
            Number(formik.values.MarketingSales) +
            Number(formik.values.AdminWages) +
            Number(formik.values.vpConstructionOperations) +
            Number(formik.values.Facilities) +
            Number(formik.values.Office) +
            Number(formik.values.GeneralAdmin)
        );
    };

    return (
        <>
            <div className="card">
                <Toast ref={toast} />

                {/* ---------------------------------------------------------------*/}
                <Dialog header="Income Statement" headerClassName="centered-header" visible={isModalOpen} maximizable style={{ width: '40vw' }} dismissableMask="true" onHide={() => { setIsModalOpen(false); closeModel(); }}>
                    <div className=''>
                        <form className="m-5 mt-0 mb-0" onSubmit={formik.handleSubmit} >
                            <div className="formgrid grid">


                                <div className="col-4 p-2">
                                    <label className='text-gray-600 text-md '>Years :  <strong>{formik.values.year.name}</strong></label>

                                </div>

                                <div className="col-4 p-2">
                                    <label className='text-gray-600 text-md' >Month : <strong> {formik.values.month.name}</strong></label>

                                </div>
                                <div className="col-4 p-2 ">
                                    <label className='text-gray-600 text-md' > Reconciled</label>
                                    <Checkbox
                                        name="reconciled"
                                        className='ml-2'
                                        value={formik.values.re_complated}
                                        checked={formik.values.re_complated == 'Y' ? true : false}

                                        onChange={(e) => {
                                            const isChecked = e.target.checked;
                                            formik.setFieldValue('re_complated', isChecked ? 'Y' : 'N');
                                            setReconciled(isChecked ? 'Y' : 'N');
                                            setReconciledDataAdd('Y');

                                            // Call save API
                                            const url = Api.API_BASE_URL + 'save-income-statement-setting';
                                            const token = localStorage.getItem('authToken');
                                            const headers = {
                                                'Content-Type': 'application/json',
                                                'Authorization': token ? `Bearer ${token}` : ''
                                            };

                                            const data = {
                                                ...formik.values,
                                                re_complated: isChecked ? 'Y' : 'N',
                                                fieldName: 're_complated',
                                                fieldValue: isChecked ? 'Y' : 'N',
                                                reconciledDataAdd: 'Y'
                                            };

                                            fetch(url, {
                                                method: "POST",
                                                headers,
                                                body: JSON.stringify(data),
                                            })
                                                .then((response) => response.json())
                                                .then((json) => {
                                                    if (json.error) {
                                                        toast.current.show({ severity: 'error', summary: 'Error', detail: json.error });
                                                    }

                                                    toast.current.show({ severity: 'success', summary: 'Success', detail: 'Reconciled status saved' });
                                                })
                                                .catch((error) => {
                                                    console.error("Error:", error);
                                                });

                                            console.log(isChecked ? 'clicked' : 'unchecked');
                                        }}
                                    />
                                </div>


                                <div className="formgrid grid income-card mt-3 w-full">
                                    <div className="col-12 p-2 income-border " >
                                        <lable className='text-md font-medium' >INCOME STATEMENT</lable>
                                    </div>
                                    {renderInputArea2(Number(formik.values.total_income_forecast), 'Total Income (Forecast)', 'This is pulled from Revenue Projection (Fee Per Month + Direct Cost')}
                                    {renderInputArea('totalIncome', 'Total Income (Actual)', "Enter actual COGS manually")}         
                                    {renderInputArea('totalOtherIncome', 'Total Other Income', 'This is entered manually')}                                    

                                    {renderInputArea('poc', 'POC', "POC is entered manually and duplicate in all future months if that month is not reconciled")}                                                                        
                                    {renderInputArea2((Number(formik.values.totalIncome) === 0 ? Number(formik.values.total_income_forecast) : Number(formik.values.totalIncome)) + Number(formik.values.poc) + Number(formik.values.totalOtherIncome) + Number(formik.values.cashend), 'Subtotal', 'This is total of Total Income, POC, Total Other Income and Previous month Cash End')}
                                </div>

                                <div className="formgrid grid income-card mt-5 w-full">
                                    <div className="col-12 p-2 income-border ">
                                        <lable className='text-md font-medium' >COST OF GOODS SOLD</lable>
                                    </div>
                                    {renderInputArea2(Number(formik.values.total_cogs_forecast), 'Total COGS (Forecast)', 'COGS is pulled from Revenue Projection (Total Direct Cost)')}    
                                    {renderInputArea('cogsTotal', 'Total COGS (Actual)', 'Enter actual COGS manually')}
                                </div>

                                <div className="formgrid grid income-card mt-5 w-full">
                                    <div className="col-12 p-2 income-border ">
                                        <lable className='text-md font-medium' >GROSS PROFIT</lable>
                                    </div>

                                    {renderInputArea2(((Number(formik.values.totalIncome) === 0 ? Number(formik.values.total_income_forecast) : Number(formik.values.totalIncome)) + Number(formik.values.poc) + Number(formik.values.totalOtherIncome)) - (Number(formik.values.cogsTotal) === 0 ? Number(formik.values.total_cogs_forecast) : Number(formik.values.cogsTotal)), 'Gross Profit', "Gross Profit formula is Total Income + POC + Total Other Income - COGS Total")}

                                    {renderInputAreaPer((((Number(formik.values.totalIncome) === 0 ? Number(formik.values.total_income_forecast) : Number(formik.values.totalIncome)) + Number(formik.values.poc) + Number(formik.values.totalOtherIncome)) - (Number(formik.values.cogsTotal) === 0 ? Number(formik.values.total_cogs_forecast) : Number(formik.values.cogsTotal))) / ((Number(formik.values.totalIncome) === 0 ? Number(formik.values.total_income_forecast) : Number(formik.values.totalIncome)) + Number(formik.values.poc) + Number(formik.values.totalOtherIncome)) * 100, 'Gross Profit %', 'Gross Profit % formula is (Gross Profit / Total Income) * 100')}
                                </div>

                                <div className="formgrid grid income-card mt-5 w-full">
                                    <div className="col-12 p-2 income-border ">
                                        <lable className='text-md font-medium' >EXPENSES</lable>
                                    </div>
                                    {renderInputArea('uncategorized', 'Uncategorized', 'This is entered manually')}
                                    {renderInputArea('MarketingSales', 'Marketing & Sales', 'This is entered manually')}
                                    {/* <div className='w-full flex gap-2 p-2 income-card-inside'>
                                        {renderInputArea('AdminWages', 'Admin Wages', true)}

                                        {renderInputArea('vpConstructionOperations', 'VP Construction Operations', true)}
                                    </div> */}
                                    {/* //?-------Updated By Suraj 18 feb 2025------------ */}
                                    <fieldset className="p-1 border rounded w-full income-card-inside">
                                        <legend className="flex items-center gap-2">
                                            {/* {showCheckbox && ( */}
                                            <Checkbox
                                                name="AdminWagesFixedTick"
                                                value={formik.values.AdminWagesFixedTick}
                                                checked={formik.values.AdminWagesFixedTick == 'Y' ? true : false}
                                                onChange={(e) => {
                                                    formik.setFieldValue('AdminWagesFixedTick', e.target.checked ? 'Y' : 'N');
                                                }}
                                                className='ml-2'

                                            />

                                            {/* )} */}
                                        </legend>
                                        <div className='flex  w-full'>
                                            {renderInputArea('vpConstructionOperations', 'VP Construction Operations', 'If ticked, this will be fixed and not changeable')}
                                            {renderInputArea('AdminWages', 'Admin Wages', 'if ticked, this will be fixed and not changeable')}
                                        </div>
                                    </fieldset>



                                    {renderInputArea('Facilities', 'Facilities', 'This is entered manually')}
                                    {renderInputArea('Office', 'Office', 'This is entered manually')}
                                    {renderInputArea('GeneralAdmin', 'General & Admin', 'This is entered manually')}
                                    {/* Render Total Expenses */}
                                    {renderInputArea2(getTotalExpenses(), 'Total Expenses', 'Total Expenses formula is sum of all expenses')}
                                </div>

                                <div className="formgrid grid income-card mt-5 w-full">
                                    <div className="col-12 p-2 income-border ">
                                        <lable className='text-md font-medium' >NET PROFIT</lable>
                                    </div>
                                    {renderInputArea2(((Number(formik.values.totalIncome) === 0 ? Number(formik.values.total_income_forecast) : Number(formik.values.totalIncome)) + Number(formik.values.poc) + Number(formik.values.totalOtherIncome) + Number(formik.values.cashend)) - ((Number(formik.values.cogsTotal) === 0 ? Number(formik.values.total_cogs_forecast) : Number(formik.values.cogsTotal)) + Number(formik.values.uncategorized) + Number(formik.values.MarketingSales) + Number(formik.values.AdminWages) + Number(formik.values.Facilities) + Number(formik.values.Office) + Number(formik.values.GeneralAdmin)), 'Subtotal', 'This is total of Total Income, POC, Total Other Income, Cash End and Total Expenses')}


                                    {renderInputArea2(((Number(formik.values.totalIncome) === 0 ? Number(formik.values.total_income_forecast) : Number(formik.values.totalIncome)) + Number(formik.values.poc) + Number(formik.values.totalOtherIncome) - (Number(formik.values.cogsTotal) === 0 ? Number(formik.values.total_cogs_forecast) : Number(formik.values.cogsTotal)) - Number(formik.values.uncategorized) - Number(formik.values.MarketingSales) - Number(formik.values.AdminWages) - Number(formik.values.Facilities) - Number(formik.values.Office) - Number(formik.values.GeneralAdmin)), 'Net Profit', 'Net Profit formula is Total Income + POC + Total Other Income - COGS Total - Total Expenses')}
                                </div>

                                <div className="formgrid grid income-card mt-5 w-full">
                                    <div className="col-12 p-2 income-border ">
                                        <lable className='text-md font-medium' >PROJECTIONS AND ASSUMPTIONS</lable>
                                    </div>
                                    {renderInputArea('custome_home_and_renovation', 'Custome Home and Renovation', 'This is entered manually')}
                                    {renderInputArea('commercial_and_multi_family', 'Commercial and Multi Family', 'This is entered manually')}

                                </div>

                                <div className="formgrid grid income-card mt-5 w-full">
                                    <div className="col-12 p-2 income-border ">
                                        <lable className='text-md font-medium' >BALANCE SHEET</lable>
                                    </div>

                                    {renderInputArea('TotalAccountsReceievable', 'Total Accounts Receievable ', 'This is the month end balance - Dave Stephens')}
                                    {renderInputArea('TotalOtherCurrentAssets', 'Total Other Current Assets', 'This is the change in the month. Black is minus red is plus.-Dave Stephens')}
                                    {renderInputArea('MaterialsForFutureJobs', 'Materials For Future Jobs','Account S.54P in Current Assets - here for ratios and not included in Cashflow formula')}
                                    {renderInputArea('DueFromToShareholder', 'Due From To Shareholder', 'Account 1348 in Current Assets - here for ratios and not included in Cashflow formula')}
                                    {renderInputArea('WipCostsInExcessOfBillings', 'Wip Costs In Excess Of Billings', 'Account S150 in Current Assets - here for ratios and not included in Cashflow formula')}
                                    {renderInputArea('TotalFixedAssets', 'Total Fixed Assets',  'This is the change in the month. Black is minus red is plus-Dave Stephens')}
                                    {/* {renderInputArea('TotalOtherAssets', 'Total Other Assets', 'This is the change in the month. Black is minus red is plus  -Dave Stephens')} */}
                                    {/* {renderInputArea('TotalCurrentAssets', 'Total Current Assets', 'This is entered manually')} */}
                                    {renderInputArea('TotalCurrentLiabilities', 'Total Current Liabilities', 'This is the month end balance -Dave Stephens')}
                                    {renderInputArea('TotalLongTermLiabilities', 'Total Long Term Liabilities', 'This is the change in the month. Black is minus red is plus.  Is this correct? -Dave Stephens')}
                                    {renderInputArea('TotalEquity', 'Total Equity', 'At the very bottom of balance sheet - here for ratios and not included in Cashflow formula')}
                                    {renderInputArea('CorpTaxPaid', 'Corp Tax Paid', 'manually entered')}
                                    {/* {renderInputArea('ConstructionFinancing', 'Construction Financing', 'manually entered')} */}
                                    {renderInputArea('ToBalanceCash', 'To Balance Cash', 'manually entered')}

                                    {renderInputArea2(getCashEndData(), 'Cash End', 'Cash End formula is Subtotal + BV30 to BV37 + BV42 to BV46 - BJ32 to BJ34 + Previous month Total Accounts Receivable + Previous month Total Current Liabilities - Previous month Total Long Term Liabilities')}

                                    <div className="col-12 p-2">
                                        <label className='text-gray-600 text-sm' >Number of employees</label>
                                        <InputText
                                            id="NumberOfEmployees"
                                            name="NumberOfEmployees"
                                            value={formik.values.NumberOfEmployees}
                                            className={classNames('p-2',)} style={{ width: '100%' }}
                                            onChange={(e) => {
                                                formik.setFieldValue('NumberOfEmployees', e.target.value);
                                            }}
                                        />
                                    </div>

                                    <div className="col-12 p-2">
                                        <label className='text-gray-600 text-sm' >Number of Management Staff</label>
                                        <InputText
                                            id="NumberOfManagementStaff"
                                            name="NumberOfManagementStaff"
                                            value={formik.values.NumberOfManagementStaff}
                                            className={classNames('p-2',)} style={{ width: '100%' }}
                                            onChange={(e) => {
                                                formik.setFieldValue('NumberOfManagementStaff', e.target.value);
                                            }}
                                        />
                                    </div>

                                    <div className="col-12 p-2">
                                        <label className='text-gray-600 text-sm'>Number of PM's</label>
                                        <InputText
                                            id="NumberOfPms"
                                            name="NumberOfPms"
                                            value={formik.values.NumberOfPms}
                                            className={classNames('p-2',)} style={{ width: '100%' }}
                                            onChange={(e) => {
                                                formik.setFieldValue('NumberOfPms', e.target.value);
                                            }}
                                        />
                                    </div>

                                </div>

                                <div className="w-full flex mt-5" style={{ justifyContent: 'center', gap: '1rem' }}>
                                    {/* <button type="submit" title='Save' style={{ cursor: 'pointer' }} className="customSave-button m-2" >
                                        <div className='flex items-center gap-2 px-1 ' style={{ alignItems: 'center' }}>
                                            <BiCheck size={20} />
                                            <span>SAVE</span>
                                        </div>
                                    </button> */}
                                    
                                    <button 
                                        type="button" 
                                        title='Close' 
                                        onClick={() => closeModel()} 
                                        style={{ cursor: 'pointer' }} 
                                        className="customCancel-button m-2"
                                    >
                                        <div className='flex items-center gap-2 px-1' style={{ alignItems: 'center' }}>
                                            <span>CLOSE</span>
                                        </div>
                                    </button>
                                </div>

                            </div>

                        </form>

                    </div>
                </Dialog>
                {/* ----------------------Projection Setting-----------------------------------------*/}
            </div>
        </>
    )
}

export default ProjectionAddModel

